const FINANCE_PRODUCTS_UK = {
  pcp: {
    id: 'pcp',
    label: 'PCP',
    selected: false,
  },
  hp: {
    id: 'hp',
    label: 'HP',
    selected: false,
  },
};

export { FINANCE_PRODUCTS_UK };
